import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({

        apiKey: "AIzaSyDtUs_4nn6M7NC_GbwqR1pYFLoEtV3HBvw",
        authDomain: "clone-b8bce.firebaseapp.com",
        databaseURL: "https://clone-b8bce.firebaseio.com",
        projectId: "clone-b8bce",
        storageBucket: "clone-b8bce.appspot.com",
        messagingSenderId: "422475868684",
        appId: "1:422475868684:web:2b3437fb3a953826079c29",
        measurementId: "G-LEJNG0V0TV"
      
})

const db = firebaseApp.firestore()
const auth = firebase.auth()

export{ db, auth }